export default __webpack_public_path__ + "static/media/stuart-marshall-2018-contributions.fe271fa0.png";